import React, { PureComponent } from 'react';
import { Form, FormGroup, FormError } from '../../../../components/Forms/Forms';
import { Input } from '../../../../components/Forms/fields/index';
import rules from '../../../../components/Forms/rules';
import Modal from '../../../../components/Modal';
import config from '../../../../../../config';


class LinkedAccountModalView extends PureComponent {
  render() {
    const {
      closeLinkedAccountModal,
      formState,
      submitForm,
      type,
      onFormUpdate,
    } = this.props;

    return (
      <Modal
        className="modal-container linked-account-modal"
        active
        onClose={() => closeLinkedAccountModal()}
      >
        <Form state={formState} onSubmit={submitForm} onChange={onFormUpdate}>

          <div className="actions">
            <div className="form-items">

              <div className="info-box">
                <h3>Account information</h3>
                <FormGroup>
                  <label>Username</label>
                  <Input
                    type="text"
                    name="username"
                    disabled
                    validate={[rules.required()]}
                  />
                  <FormError/>
                </FormGroup>
                <FormGroup>
                  <label>Password</label>
                  <Input
                    type="text"
                    name="password"
                    disabled
                    validate={[rules.required()]}
                  />
                  <FormError/>
                </FormGroup>
                <FormGroup>
                  <label>2 Factor Code</label>
                  <Input
                    type="text"
                    name="totp_secret"
                    disabled
                  />
                  <FormError/>
                </FormGroup>
                <FormGroup>
                  <label>Max orders per day</label>
                  <Input
                    type="number"
                    name="max_orders_per_day"
                  />
                  <FormError/>
                </FormGroup>
                <FormGroup>
                  <label>Max spend per day</label>
                  <Input
                    type="number"
                    name="max_spend_per_day"
                  />
                  <FormError/>
                </FormGroup>
                <FormGroup>
                  <label>Min order order value</label>
                  <Input
                    type="number"
                    name="min_order_value"
                  />
                  <FormError/>
                </FormGroup>
                <FormGroup>
                  <label>Max order value</label>
                  <Input
                    type="number"
                    name="max_order_value"
                  />
                  <FormError/>
                </FormGroup>
                <FormGroup>
                  <label>HTTP Proxy URL</label>
                  <Input
                    type="text"
                    name="proxy_url"
                  />
                  <FormError/>
                </FormGroup>
                <FormGroup>
                  <label>Max orders lifetime</label>
                  <Input
                    type="number"
                    name="max_orders_lifetime"
                  />
                  <FormError/>
                </FormGroup>
                <FormGroup>
                  <label>Max spend lifetime</label>
                  <Input
                    type="number"
                    name="max_spend_lifetime"
                  />
                  <FormError/>
                </FormGroup>
                <FormGroup>
                  <label>Hours between orders</label>
                  <Input
                    type="number"
                    name="order_gap"
                  />
                  <FormError/>
                </FormGroup>
                <FormGroup>
                  <label>Max unshiped orders</label>
                  <Input
                    type="number"
                    name="max_orders_unshipped"
                  />
                  <FormError/>
                </FormGroup>
                <FormGroup>
                  <label>Max unshiped spend</label>
                  <Input
                    type="number"
                    name="max_spend_unshipped"
                  />
                  <FormError/>
                </FormGroup>
                <FormGroup>
                  <label>Ordering every N day</label>
                  <Input
                    type="number"
                    name="ordering_days"
                  />
                  <FormError/>
                </FormGroup>
              </div>
              <div className="address-box">
                <h3>Billing Address</h3>

                <FormGroup>
                  <label>First Name</label>
                  <Input
                    type="text"
                    name="billing_address.first_name"
                    validate={[rules.required()]}
                  />
                  <FormError/>
                </FormGroup>

                <FormGroup>
                  <label>Last Name</label>
                  <Input
                    type="text"
                    name="billing_address.last_name"
                  />
                  <FormError/>
                </FormGroup>

                <FormGroup>
                  <label>Address Line 1</label>
                  <Input
                    type="text"
                    name="billing_address.address_line1"
                    validate={[rules.required()]}
                  />
                  <FormError/>
                </FormGroup>

                <FormGroup>
                  <label>Address Line 2</label>
                  <Input
                    type="text"
                    name="billing_address.address_line2"
                  />
                  <FormError/>
                </FormGroup>

                <FormGroup>
                  <label>City</label>
                  <Input
                    type="text"
                    name="billing_address.city"
                    validate={[rules.required()]}
                  />
                  <FormError/>
                </FormGroup>

                <FormGroup>
                  <label>State</label>
                  <Input
                    type="text"
                    name="billing_address.state"
                    validate={[rules.required()]}
                  />
                  <FormError/>
                </FormGroup>

                <FormGroup>
                  <label>ZIP code</label>
                  <Input
                    type="text"
                    name="billing_address.zip_code"
                    validate={[rules.required()]}
                  />
                  <FormError/>
                </FormGroup>

                <FormGroup>
                  <label>Phone Number</label>
                  <Input
                    type="text"
                    name="billing_address.phone_number"
                    validate={[rules.required()]}
                  />
                  <FormError/>
                </FormGroup>
              </div>
            </div>
            <button type="submit" className="button">Save</button>
          </div>
        </Form>
      </Modal>
    )
  }
}

export default LinkedAccountModalView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Data/LinkedAccountModal/LinkedAccountModal.view.js